export default function () {
    return {
        conversation: [],
    }
}